// @flow
import { OptionAnswersOpinometroActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    optionAnswerOpinometro: {},
    listaOptionAnswersOpinometro: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false
};

type OptionAnswersOpinometroAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { optionAnswerOpinometro?: {} | null, listaOptionAnswersOpinometro?: [] | null, loading?: boolean, +value ?: boolean };

const OptionAnswersOpinometro = (state: State = INIT_STATE, action: OptionAnswersOpinometroAction): any => {
    // console.log(action);
    switch (action.type) {
        case OptionAnswersOpinometroActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case OptionAnswersOpinometroActionTypes.GET_OPTION_ANSWER_OPINOMETRO: {
                    return {
                        ...state,
                        optionAnswerOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OptionAnswersOpinometroActionTypes.LIST_OPTION_ANSWERS_OPINOMETRO: {
                    return {
                        ...state,
                        listaOptionAnswersOpinometro: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case OptionAnswersOpinometroActionTypes.ADD_OPTION_ANSWER_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OptionAnswersOpinometroActionTypes.UPDATE_OPTION_ANSWER_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OptionAnswersOpinometroActionTypes.DELETE_OPTION_ANSWER_OPINOMETRO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OptionAnswersOpinometroActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case OptionAnswersOpinometroActionTypes.GET_OPTION_ANSWER_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        optionAnswerOpinometro: {},
                        loading: false,
                    };
                }
                case OptionAnswersOpinometroActionTypes.LIST_OPTION_ANSWERS_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaOptionAnswersOpinometro: [],
                        loading: false,
                    };
                }
                case OptionAnswersOpinometroActionTypes.ADD_OPTION_ANSWER_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OptionAnswersOpinometroActionTypes.UPDATE_OPTION_ANSWER_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case OptionAnswersOpinometroActionTypes.DELETE_OPTION_ANSWER_OPINOMETRO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case OptionAnswersOpinometroActionTypes.GET_OPTION_ANSWER_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case OptionAnswersOpinometroActionTypes.LIST_OPTION_ANSWERS_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case OptionAnswersOpinometroActionTypes.ADD_OPTION_ANSWER_OPINOMETRO:
            return { ...state, error: false, loadingForm: true };
        case OptionAnswersOpinometroActionTypes.UPDATE_OPTION_ANSWER_OPINOMETRO:
            return { ...state, error: false, loadingForm: true };
        case OptionAnswersOpinometroActionTypes.DELETE_OPTION_ANSWER_OPINOMETRO:
            return { ...state, error: false, loading: true };
        case OptionAnswersOpinometroActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                optionAnswerOpinometro: {},
                listaOptionAnswersOpinometro: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default OptionAnswersOpinometro;
